import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BulkUploadComponent } from './components/dashboard/bulk-upload/bulk-upload.component';
import { CasesComponent } from './components/dashboard/cases/cases.component';
import { PayeeCaseMokkComponent } from './components/dashboard/payee-case-mokk/payee-case-mokk.component';
import { ClientsListComponent } from './components/dashboard/clients-list/clients-list.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { EnumsComponent } from './components/dashboard/enums/enums.component';
import { LawFirmsComponent } from './components/dashboard/law-firms/law-firms.component';
import { CaseStartsComponent } from './components/dashboard/metrics/case-starts/case-starts.component';
import { MetricsComponent } from './components/dashboard/metrics/metrics.component';
import { SoftPaidComponent } from './components/dashboard/metrics/soft-paid/soft-paid.component';
import { PartnersListComponent } from './components/dashboard/partners-list/partners-list.component';
import { ProductDiscountsComponent } from './components/dashboard/product-discounts/product-discounts.component';
import { ProductPricesComponent } from './components/dashboard/product-prices/product-prices.component';
import { RolesComponent } from './components/dashboard/roles/roles.component';
import { FailedJobsComponent } from './components/dashboard/szamlazzhu/failed-jobs/failed-jobs.component';
import { InvoiceFormTableComponent } from './components/dashboard/szamlazzhu/invoice-form-table/invoice-form-table.component';
import { InvoiceResendComponent } from './components/dashboard/szamlazzhu/invoice-resend/invoice-resend.component';
import { InvoicesTableComponent } from './components/dashboard/szamlazzhu/invoices-table/invoices-table.component';
import { KsziInfoComponent } from './components/dashboard/szamlazzhu/kszi-info/kszi-info.component';
import { MissingRefIdsComponent } from './components/dashboard/szamlazzhu/missing-ref-ids/missing-ref-ids.component';
import { SzamlazzhuComponent } from './components/dashboard/szamlazzhu/szamlazzhu.component';
import { GetPasswordLinkSuccessComponent } from './components/forgot-password/get-password-link-success/get-password-link-success.component';
import { GetPasswordLinkComponent } from './components/forgot-password/get-password-link/get-password-link.component';
import { NewPasswordSuccessComponent } from './components/forgot-password/new-password-success/new-password-success.component';
import { NewPasswordComponent } from './components/forgot-password/new-password/new-password.component';
import { LoginComponent } from './components/login/login/login.component';
import { TwofaFormComponent } from './components/login/twofa-form/twofa-form.component';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';
import { WorkflowEditorComponent } from './components/dashboard/workflow-editor/workflow-editor.component';
import { InfoNotificationsComponent } from './components/dashboard/info-notifications/info-notifications.component';
import { translateTitle as resolveTranslateTitle } from './shared/services/title/translate-title.resolver';
import { withTestTitlePrefix } from './shared/services/title/with-test-title-prefix.resolver';

const translateTitle = (key: string) => withTestTitlePrefix(resolveTranslateTitle(key));

const routes: Routes = [
  {
    path: 'admin',
    component: DashboardComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: 'bulk-upload', component: BulkUploadComponent },
      { path: 'workflow-editor', component: WorkflowEditorComponent },
      { path: 'law-firms', component: LawFirmsComponent },
      { path: 'info-notifications', component: InfoNotificationsComponent },
      {
        path: 'metrics',
        component: MetricsComponent,
        children: [
          { path: 'case-starts', component: CaseStartsComponent },
          { path: 'soft-paid', component: SoftPaidComponent },
          { path: '**', redirectTo: 'case-starts' },
        ],
      },
      // {
      //   path: 'users-list',
      //   component: UsersListComponent,
      // },
      {
        path: 'clients',
        component: ClientsListComponent,
        title: translateTitle('BROWSER_TITLES.CLIENTS'),
      },
      {
        path: 'cases-list',
        component: CasesComponent,
        title: translateTitle('BROWSER_TITLES.CASES'),
      },
      {
        path: 'payee-case-mokk',
        component: PayeeCaseMokkComponent,
        title: translateTitle('BROWSER_TITLES.PAYEE_CASE_MOKK'),
      },
      {
        path: 'enums',
        component: EnumsComponent,
        title: translateTitle('BROWSER_TITLES.ENUMS'),
      },
      {
        path: 'szamlazzhu',
        component: SzamlazzhuComponent,
        children: [
          {
            path: 'invoices',
            component: InvoicesTableComponent,
          },
          {
            path: 'invoice-form',
            component: InvoiceFormTableComponent,
          },
          {
            path: 'kszi-info',
            component: KsziInfoComponent,
          },
          {
            path: 'invoice-resend',
            component: InvoiceResendComponent,
          },
          {
            path: 'kszi-info',
            component: KsziInfoComponent,
          },
          {
            path: 'failed-jobs',
            component: FailedJobsComponent,
          },
          {
            path: 'missing-ref-ids',
            component: MissingRefIdsComponent,
          },
          {
            path: '**',
            redirectTo: 'invoices',
          },
        ],
      },
      {
        path: 'partners',
        component: PartnersListComponent,
      },
      {
        path: 'users',
        component: RolesComponent,
      },
      {
        path: 'product-prices',
        component: ProductPricesComponent,
      },
      {
        path: 'product-discounts',
        component: ProductDiscountsComponent,
      },
      { path: '**', redirectTo: 'cases-list' },
    ],
  },
  {
    path: 'forgot-password-get-link',
    component: GetPasswordLinkComponent,
    title: translateTitle('BROWSER_TITLES.PASSWORD_RESET'),
  },
  {
    path: 'forgot-password-get-link-success',
    component: GetPasswordLinkSuccessComponent,
    title: translateTitle('BROWSER_TITLES.PASSWORD_RESET'),
  },
  {
    path: 'forgot-password-new-password/:token',
    component: NewPasswordComponent,
    title: translateTitle('BROWSER_TITLES.PASSWORD_RESET'),
  },
  {
    path: 'forgot-password-new-password-success',
    component: NewPasswordSuccessComponent,
    title: translateTitle('BROWSER_TITLES.PASSWORD_RESET'),
  },
  { path: 'login', component: LoginComponent, title: translateTitle('BROWSER_TITLES.LOGIN') },
  {
    path: '2fa',
    children: [
      { path: '', redirectTo: 'verify', pathMatch: 'full' },
      {
        path: 'verify',
        component: TwofaFormComponent,
        title: translateTitle('BROWSER_TITLES.TWO_FACTOR'),
      },
    ],
  },
  { path: '**', redirectTo: 'admin' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
